import { api } from 'shared';
import { z } from 'zod';

export const OutdoorBarArticleCategoriesResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
        }),
    ),
});
export const fetchOutdoorBarArticleCategories = async () => (
    api.get<z.infer<typeof OutdoorBarArticleCategoriesResponseSchema>>(
        '/outdoor-bar-article-categories',
        {},
        OutdoorBarArticleCategoriesResponseSchema,
    )
);
